function calcAverage(data) {
  var sum = data.reduce(function (sum, value) {
    if (value.consumo && value.consumo * 1 > 0) {
      return sum + value.consumo;
    } else {
      return sum;
    }
  }, 0);
  var tam = data.filter((value) => value.consumo * 1 > 0).length;
  var avg = sum / tam;

  return avg;
}

function calcMediana(data) {
  var values = [];
  data.reduce(function (sum, value) {
    if (value.consumo && value.consumo * 1 > 0) {
      return values.push(value.consumo);
    }
  }, 0);
  values = values.sort();
  let tam = values.length;
  if (tam % 2 == 0) {
    return (values[tam / 2 - 1] + values[tam / 2]) / 2;
  } else {
    tam++;
    return values[tam / 2 - 1];
  }
}

function calcCustoDisp(classe) {
  switch (classe) {
    case "Monofásico":
      return 30;
    case "Bifásico":
      return 50;
    case "Trifásico":
      return 100;
    default:
      return 50;
  }
}

function desvioPadrao(average, data) {
  var values = [];
  var sum = 0;
  data.reduce(function (sum, value) {
    if (value.consumo && value.consumo * 1 > 0) {
      return values.push(value.consumo);
    }
  }, 0);
  values.forEach((value) => {
    sum += (value - average) ** 2;
  });
  return Math.sqrt(sum / values.length);
}

function calcCreditos(media, mediana, desvio_padrao, custo_disp) {
  const perc_desvio = desvio_padrao / media;
  if (perc_desvio > 0.2) {
    const dif = media - mediana;
    return mediana - custo_disp + dif * 1; //Fórmula C
  } else return mediana - desvio_padrao / 2 - custo_disp; //Fórmula B
}

export const calcconsumerunit = (consumerunit) => {
  const average = calcAverage(consumerunit.history);
  const mediana = calcMediana(consumerunit.history);
  const desvio_padrao = desvioPadrao(average, consumerunit.history);
  const custo_disp = calcCustoDisp(consumerunit.rate_class);
  const tarifa = consumerunit.fare_amount || 0;
  const creditosKWH = calcCreditos(average, mediana, desvio_padrao, custo_disp);
  const creditos = creditosKWH * tarifa;
  const discount = consumerunit.percentage_discount / 100;
  const mensalidade = creditos * (1 - discount);
  let power = 221667;
  if (consumerunit.powerplant && consumerunit.powerplant.power_monthly) {
    power = consumerunit.powerplant.power_monthly || 221667;
  }
  return {
    average: parseFloat(average.toFixed(2)),
    custo_disp: parseFloat(custo_disp.toFixed(2)),
    desvio_padrao: parseFloat(desvio_padrao.toFixed(2)),
    creditos: parseFloat(creditos.toFixed(2)),
    mediana: parseFloat(mediana.toFixed(2)),
    mensalidade: parseFloat(mensalidade.toFixed(2)),
    economia_mensal: parseFloat((creditos * discount).toFixed(2)),
    economia_anual: parseFloat((creditos * discount * 12).toFixed(2)),
    economia_contrato: parseFloat((creditos * discount * 36).toFixed(2)),
    percentage: parseFloat(((creditos / power) * 100).toFixed(2)),
    paraCemigAntes: parseFloat((mediana * tarifa).toFixed(2)),
    paraCemigDepois: parseFloat((mediana * tarifa - creditos).toFixed(2)),
  };
};
